const newsletterPopup = () => {

    const newsletterPopupComponent = document.querySelector('.newsletter-popup-overlay');
    
    if (newsletterPopupComponent) {

		// If user hasn't accepted cookie, activate the popup
		if (getCookie('newsletter_popup_seen') != 'true') {
			setTimeout(function() {
				newsletterPopupComponent.classList.add('active');
			}, 1000); 
		}
		
	    const popupClose = document.querySelector('.newsletter-popup__close');
	    popupClose.addEventListener('click', function() {
	        newsletterPopupComponent.classList.remove('active');
			setCookie('newsletter_popup_seen', 'true', 1);
	    });

	    const newsletterPopupSubmit = document.getElementById('newsletter-popup-submit');

	 	newsletterPopupSubmit.addEventListener('click', function(event) {

	        const emailAddress = document.querySelector('[name="email_address"]').value;
	        const preferredLanguage = document.querySelector('[name="preferred_language"]').value;
	        const correspondence = document.querySelector('[name="correspondence"]').checked;

	        const emailErrorMessage = document.querySelector('.error-email');
	        const preferredLanguageErrorMessage = document.querySelector('.error-preferred');
	        const correspondenceErrorMessage = document.querySelector('.error-correspondence');

	        let emailError = false;
	        let preferredLanguageError = false;
	        let correspondenceError = false;

	        if(emailAddress == '' || emailAddress == null) {
	        	emailErrorMessage.classList.add('active');
	        	emailError = true;
	        } else {
	        	emailErrorMessage.classList.remove('active');
	        }

	        if(preferredLanguage == '' || preferredLanguage == null) {
	        	preferredLanguageErrorMessage.classList.add('active');
	        	preferredLanguageError = true;
	        } else {
	        	preferredLanguageErrorMessage.classList.remove('active');
	        }
	         
	        if(correspondence == false) {
	        	correspondenceErrorMessage.classList.add('active');
	        	correspondenceError = true;
	        } else {
	        	correspondenceErrorMessage.classList.remove('active');
	        }

	        if(emailError == false && preferredLanguageError == false && correspondenceError == false) {

	        	const formData = new FormData();
	        	formData.append('email_address', emailAddress);
	        	formData.append('preferred_language', preferredLanguage);
	        	formData.append('action', 'ajax_newsletter_signup');
	                            
	            const mailchimpData = new URLSearchParams(formData);

	            fetch(scriptVars.ajaxUrl, {
	                method: 'POST',
	                credentials: 'same-origin',
	                headers: {
	                    'Content-Type': 'application/x-www-form-urlencoded',
	                    'Cache-Control': 'no-cache',
	                },
	                body: mailchimpData
	            })
	            .then((response) => response.json())
	            .then((data) => {
					console.log(data.response);

	          		const newsletterForm = document.querySelector('.newsletter-popup__form');
	          		newsletterForm.style.display = 'none';

	          		const newsletterThankyou = document.querySelector('.newsletter-popup__thankyou');
	          		newsletterThankyou.innerText = data.response;

	            })
	            .catch((error) => {
	                console.error(error);
	            });  
	        }
	    });
	}
}